import Breadcrumbs from '@components/layout/Breadcrumbs';
import InvoicesList from '@components/portal/InvoicesList';

/**
 * InvoicesPage — Invoice PDF viewer
 * Route: /invoices
 *
 * Displays invoices dropped into Azure Data Lake by external invoicing app.
 * Simple list with download + share actions. Layout mirrors Cases/Orders.
 * Source: INVOICE_SOURCE = 'azure_data_lake' (see constants.js)
 */
export default function InvoicesPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Invoices' }]} />
      <h1 className="font-sandvik-headline font-bold text-2xl text-carbon-black mb-6">
        My Invoices
      </h1>
      <div className="bg-white border border-n2 p-6">
        <InvoicesList />
      </div>
    </div>
  );
}
